<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div id="relatorio" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-5">
              <div id="veiculoPeriodo">
                <div class="panel panel-default">
                  <div class="panel-body">
                    <div class="row row-margin">
                      <div id="lista-veiculos" class="col-md-12">
                        <input id="veiculoId" type="hidden" class="form-control" v-model="filtros.veiculoId">
                        <input id="clienteId" type="hidden" class="form-control" v-model="filtros.clienteId">
                        <h4 class="panel-title">Veículo:</h4>
                        <div class="row">
                          <div class="col-md-8">
                            <input id="busca" name="busca" placeholder="Filtrar veículo" class="form-control" type="text" v-model="buscaVeiculo" v-on:keyup.enter="buscarVeiculos"> 
                          </div>
                          <div class="col-md-4">
                            <button class="btn btn-success btn-block" @click="buscarVeiculos">Buscar</button>
                          </div>
                        </div>
                        <div id="dados-analise-jornada-lista-veiculos">
                          <table class="table table-responsive-sm table-hover table-outline mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th>Veículo</th>
                              </tr>
                            </thead>
                            <tbody v-for="(grid, i) in dadosGrid" >
                              <template v-if="i === 0">
                                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                </tr>
                              </template>
                              <template v-if="i > 0">
                                <template v-if="dadosGrid[i].clienteIdVeiculo != dadosGrid[i-1].clienteIdVeiculo">
                                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                </tr>
                                </template>
                              </template>
                              <tr :class="{ 'selecionado': selecionado(grid) }" @click="selecionarItem(grid)" v-on:dblclick="editar(grid.idVeiculo)">
                                <td>
                                  <small class="text-muted">{{grid.descricaoVeiculo}}</small>
                                  <template v-if="grid.marcaEquipamento == 'OBD'">
                                    <img src="/static/images/obd.png"> 
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <div class="row row-margin">
                <div class="col-md-12">
                  <h4 class="panel-title">Período:</h4>
                </div>

                <div class="col-md-6">
                  <label>Data inicial:</label><br>
                  <input-data-format :id="'dataInicial'" v-model="filtros.dataInicial" @blur.native="setarDataInicial" class="form-control pula data" />
                </div>
                <div class="col-md-6">
                  <label>Hora inicial: </label><br>
                  <input-hora-picker-ss :id="'horaInicial'" v-model="filtros.horaInicial" class="form-control pula hora" />
                </div>
              </div>
              <div class="row row-margin">
                <div class="col-md-6">
                  <label id="dataFinalLabel">Data final:</label><br>
                  <input-data-format :id="'dataFinal'" v-model="filtros.dataFinal" @blur.native="setarDataFinal" class="form-control pula data"/>
                </div>
                <div class="col-md-6">
                  <label id="horaFinalLabel">Hora final: </label><br>
                  <input-hora-picker-ss :id="'horaFinal'" v-model="filtros.horaFinal" class="form-control pula hora" />
                </div>
              </div>
              <div class="text-right">
                <small>*Os dados de rastreamento ficam armazenados por 90 dias.</small>
              </div>

              <div class="col-md-12">
                <div id="opcoesRelatorio">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h4 class="panel-title">Relatório</h4>
                    </div>
                    <div class="panel-body">
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="0"> Relatório de Posições </label> <br>
                      <template v-if="filtros.veiculoMarcaEquipamento == 'OBD'">
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="1"> Relatório de Posições OBD </label> <br> 
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="4"> Relatório de Posições OBD Viagem</label> <br> 
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="5"> Relatório de Posições OBD Fahas</label> <br> 
                      </template>
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="2"> Relatório de Análise de Trabalho e Produção </label><br>
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="3"> Relatório de Análise de Trabalho e Produção Sintético </label><br>
                      <!-- <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="4"> Relatório de Análise de Conduta </label><br>
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="5"> Relatório de Acionamento de Entrada </label><br>
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="6"> Relatório de Acionamento de Entrada Sintético</label><br>
                      <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="7"> Relatório de Distancia em Horário de Trabalho </label><br> -->

                      <template v-if="$auth.check('P110')">
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="6"> Relatório de Km Rodado por Veículo</label><br>
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="7"> Relatório de Km Rodado por Frota</label><br>
                      </template>
                    
                      <template v-if="$auth.check('P110')">
                        <label><input v-model="filtros.relatorio" type="radio" name="tipoRelatorio" value="100"> TESTE Relatório de Posições</label> <br>
                        
                      </template>
                  <br>
                  <template v-if="filtros.relatorio !== '2' && filtros.relatorio !== '3'">
                    <div class="row">
                      <div class="col-md-6">
                        <label>Filtrar velocidade maior que: </label>
                        <input class="form-control" v-model="filtros.filtroVelocidade">
                      </div>
                      <div class="col-md-6">
                        <label>Velocidade mínima para média: </label><br>
                        <input class="form-control" v-model="filtros.desprezarVelocidade">
                      </div>
                    </div>
                  </template>
                  <template v-if="filtros.relatorio === '5'">
                    <div class="row">
                      <div class="col-md-6">
                        <label>Filtrar velocidade mínima: </label>
                        <input class="form-control" v-model="filtros.filtroVelocidadeMinima">
                      </div>
                      <div class="col-md-6">
                        <label>Filtrar velocidade máxima: </label><br>
                        <input class="form-control" v-model="filtros.filtroVelocidadeMaxima">
                      </div>
                    </div>
                 </template>
                 
                  <template v-if="filtros.relatorio === '0' || filtros.relatorio === '1'">
                    <div class="row">
                      <div class="col-md-12">  
                        <label id="agruparPosicoesLabel">Agrupar Posições</label><br>
                        <select id="agruparPosicoes" class="form-control" v-model="filtros.agruparPosicoes">
                          <option value="N">Não Agrupar</option>
                          <option value="5">5 Minutos</option>
                          <option value="10">10 Minutos</option>
                        </select>
                      </div>
                    </div>
                  </template>
                  <template v-if="filtros.relatorio === '2' || filtros.relatorio === '3'">
                    <div class="row">
                      <div class="col-md-6">
                        <label id="entradaLabel">Entrada Analisada:</label><br>
                        <select id="entrada" class="form-control" v-model="filtros.entrada">
                          <option value="ignicao">Ignição</option>
                          <option value="velocidade">Velocidade</option>
                          <option value="entrada1">Entrada 1</option>
                          <option value="entrada2">Entrada 2</option>
                          <option value="entrada3">Entrada 3</option>
                          <option value="entrada4">Entrada 4</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <template v-if="filtros.entrada === 'velocidade'">
                          <label>Filtrar velocidade máxima: </label><br>
                          <input class="form-control" v-model="filtros.entradaVelocidade">
                        </template>
                      </div>
                    </div>
                  </template>

                  <template v-if="filtros.relatorio === '1'">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Ignição: </label><br>
                        <select id="entrada" class="form-control" v-model="filtros.obdIgnicao">
                          <option value="todas">Todas</option>
                          <option value="ligada">Ligada</option>
                          <option value="desligada">Desligada</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label>RPM: </label><br>
                        <input class="form-control" v-model="filtros.obdRpm">
                      </div>
                      <div class="col-md-3">
                        <label>Temperatura: </label><br>
                        <input class="form-control" v-model="filtros.obdTemperatura">
                      </div>
                      <div class="col-md-3">
                        <label>Erro: </label><br>
                        <select id="entrada" class="form-control" v-model="filtros.obdErro">
                          <option value="todas">Todas</option>
                          <option value="sim">Sim</option>
                          <option value="nao">Não</option>
                        </select>
                      </div>
                    </div>
                  </template>
                  <br>
                  <div class="row">
                    <div class="col-md-12">
                      <button id="gerarRelatorio" type="button" class="btn btn-success btn-lg btn-block" v-on:click="gerarRelatorio">
                        <span class="glyphicon glyphicon-star" aria-hidden="true"></span> Gerar Relatório
                      </button>                        
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
import LineChart from './LineChart.js'
import PieChart from './PieChart.js'
export default {
  components: {
    LineChart,
    PieChart
  },
  data () {
    return {
      filtros: {
        clienteId: this.$store.state.filtrosRelatorios.clienteId,
        veiculoId: this.$store.state.filtrosRelatorios.veiculoId,
        veiculoMarcaEquipamento: '',
        veiculoDescricao: this.$store.state.filtrosRelatorios.veiculoDescricao,
        dataInicial: (this.$store.state.filtrosRelatorios.dataInicial === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataInicial),
        horaInicial: this.$store.state.filtrosRelatorios.horaInicial,
        dataFinal: (this.$store.state.filtrosRelatorios.dataFinal === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataFinal),
        horaFinal: this.$store.state.filtrosRelatorios.horaFinal,
        relatorio: this.$store.state.filtrosRelatorios.relatorio,
        buscaVeiculo: this.$store.state.filtrosRelatorios.buscaVeiculo,
        selecionada: this.$store.state.filtrosRelatorios.selecionada,
        filtroVelocidade: this.$store.state.filtrosRelatorios.filtroVelocidade,
        filtroVelocidadeMinima: this.$store.state.filtrosRelatorios.filtroVelocidadeMinima,
        filtroVelocidadeMaxima: this.$store.state.filtrosRelatorios.filtroVelocidadeMaxima,
        desprezarVelocidade: '5',
        agruparPosicoes: this.$store.state.filtrosRelatorios.agruparPosicoes,
        entrada: this.$store.state.filtrosRelatorios.entrada,
        entradaVelocidade: this.$store.state.filtrosRelatorios.entradaVelocidade,
        obdIgnicao: this.$store.state.filtrosRelatorios.obdIgnicao,
        obdRpm: this.$store.state.filtrosRelatorios.obdRpm,
        obdTemperatura: this.$store.state.filtrosRelatorios.obdTemperatura,
        obdErro: this.$store.state.filtrosRelatorios.obdErro,
        agrupar: this.$store.state.filtrosRelatorios.agrupar,
        formato: 'visualizacao'
      },
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      buscaVeiculo: '',
      processando: false
    }
  },
  mounted () {
    // this.buscarVeiculos()
    // $(this.$el).find('#veiculoDescricao').val(this.$store.state.filtrosRelatorios.veiculoDescricao)
    this.buscarVeiculos()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
      this.filtros.veiculoId = item.idVeiculo
      this.filtros.veiculoMarcaEquipamento = item.marcaEquipamento
    },
    selecionado: function (item) {
      return this.filtros.veiculoId === item.idVeiculo
    },
    buscarGrid: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGrid = dadosCadastro
        self.processando = false
      })
    },
    buscarVeiculos: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos/buscarVeiculosAtivos?busca=' + this.buscaVeiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGrid = dadosCadastro
        self.processando = false
      })
    },
    setarDataInicial: function (e) {
      console.log('set inicial')
      console.log(e)
      console.log(e.target)

      this.filtros.dataInicial = $(this.$el).find('#dataInicial').val()
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val()
      this.filtros.dataFinal = this.filtros.dataInicial
      console.log($(this.$el).find('#dataFinal').val($(this.$el).find('#dataInicial').val()))
    },
    setarDataFinal: function () {
      console.log('set final')
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val()
      // console.log('set final: ' + this.diasEntreDadas(this.filtros.dataInicial, this.filtros.dataFinal))
      // if (this.diasEntreDadas(this.filtros.dataInicial, this.filtros.dataFinal) <= 0) {
      //   // this.filtros.dataInicial = this.filtros.dataFinal
      //   console.log('set final')
      // }
    },
    setarVeiculo: function (veiculo) {
      this.model.veiculoId = veiculo.id
      this.model.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculo: function () {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.filtros.veiculoId = 0
        this.filtros.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.filtros.veiculoId = 0
        this.filtros.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
    },
    // buscarVeiculos: function () {
    //   var self = this
    //   self.processando = true
    //   var dadosCadastro
    //   var config = {
    //     headers: {'Authorization': 'Bearer ' + this.$store.state.token}
    //   }
    //   var url = '/api/listarVeiculos?busca=' + this.buscaVeiculo
    //   axios.get(url, config)
    //   .then(function (response) {
    //     console.log(response.data)
    //     dadosCadastro = response.data
    //     self.dadosVeiculos = dadosCadastro
    //     self.processando = false
    //   })
    // },
    gerarRelatorio: function () {
      let self = this
      let clienteId = self.filtros.veiculoId
      let veiculoId = self.filtros.veiculoId
      let dataHoraInicial = self.filtros.dataInicial + ' ' + self.filtros.horaInicial + ':00'
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-')
      let dataHoraFinal = self.filtros.dataFinal + ' ' + self.filtros.horaFinal + ':59'
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-')
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção')
        return
      }
      if (this.diasEntreDadas(this.filtros.dataInicial, this.filtros.dataFinal) < 0) {
        self.$toastr('error', 'Verifique o Período do relatório.', 'Atenção')
        return
      }
      if (self.filtros.relatorio === '0' || self.filtros.relatorio === '1') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 2) {
          self.$toastr('error', 'O Período não pode ser superior a 2 dias.', 'Atenção')
          return
        }
      }
      if (self.filtros.relatorio === '2') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 16) {
          // self.$toastr('error', 'A analise deve ser do mesmo dia.', 'Atenção')
          self.$toastr('error', 'O Período não pode ser superior a 16 dias.', 'Atenção')
          return
        }
      }
      if (self.filtros.relatorio === '3') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 16) {
          self.$toastr('error', 'O Período não pode ser superior a 16 dias.', 'Atenção')
          return
        }
      }
      self.$store.commit('SET_FILTROS_RELATORIOS', self.filtros)
      //
      if (self.filtros.relatorio === 0 || self.filtros.relatorio === '0') {
        self.$router.replace('/relatorioDePosicoesView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes)
      } else if (self.filtros.relatorio === 1 || self.filtros.relatorio === '1') {
        self.$router.replace('/relatorioDePosicoesObdView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes + '/' + self.filtros.obdIgnicao + '/' + self.filtros.obdRpm + '/' + self.filtros.obdTemperatura + '/' + self.filtros.obdErro)
      } else if (self.filtros.relatorio === 2 || self.filtros.relatorio === '2') {
        self.$router.replace('/relatorioDeAnaliseTrabalhoProducaoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada + '/' + self.filtros.entradaVelocidade)
      } else if (self.filtros.relatorio === 3 || self.filtros.relatorio === '3') {
        self.$router.replace('/relatorioDeAnaliseTrabalhoProducaoSinteticoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada + '/' + self.filtros.entradaVelocidade)
      } else if (self.filtros.relatorio === 4 || self.filtros.relatorio === '4') {
        self.$router.replace('/relatorioDePosicoesObdTripView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes + '/' + self.filtros.obdIgnicao + '/' + self.filtros.obdRpm + '/' + self.filtros.obdTemperatura + '/' + self.filtros.obdErro)
      } else if (self.filtros.relatorio === 5 || self.filtros.relatorio === '5') {
        self.$router.replace('/relatorioDeAcionamentoDeEntradaView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidadeMinima + '/' + self.filtros.filtroVelocidadeMaxima + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada)
      } else if (self.filtros.relatorio === 6 || self.filtros.relatorio === '6') {
        self.$router.replace('/relatorioDeKmRodadoVeiculoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal)
      } else if (self.filtros.relatorio === 7 || self.filtros.relatorio === '7') {
        self.$router.replace('/relatorioDeKmRodadoFrotaView/' + clienteId + '/' + dataHoraInicial + '/' + dataHoraFinal)
      } else if (self.filtros.relatorio === 100 || self.filtros.relatorio === '100') {
        self.$router.replace('/relatorioDePosicoesNovoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/Relatorios.vue